import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {JobsComponent} from './jobs.component';
import {HeaderDetailComponent} from './component/header-detail/header-detail.component';
import {SubDetailComponent} from './component/sub-detail/sub-detail.component';
import {CultureDetailComponent} from './component/culture-detail/culture-detail.component';
import {JobsDetailComponent} from './component/jobs-detail/jobs-detail.component';
import {CollapseModule} from 'ngx-bootstrap/collapse';


@NgModule({
  declarations: [
    JobsComponent,
    HeaderDetailComponent,
    SubDetailComponent,
    CultureDetailComponent,
    JobsDetailComponent
  ],
  imports: [
    CollapseModule,
    CommonModule
  ]
})
export class JobsModule {
}
